import React from "react";
import styles from "../css/IntroduceDetail.css";
import { Header } from "./Introduce";


const app = () => {
  return (
    <div style={{ flex: 1 }}>
      <Header text="实验室介绍"></Header>
      <div className={styles.main}>
        <p className={styles.p}>
        清华大学分析中心始建于1972年是校内第一个公共测试平台，1985年清华大学化学系复系，原分析化学教研室与清华大学分析中心整合成为集教学、科研、服务三位一体的实体，是以分析化学学科为引领方向，以大型仪器的开放服务支撑学校教学科研活动的测试平台。中心围绕化学及其相关交叉学科的关键科学问题和高水平分析测试需求，本着“科学、公正、准确、满意 ”的服务宗旨，长期为全校及部分外校单位提供测试服务。
        </p>

        <p className={styles.p}>
        色谱分析是近20年发展最快的分析技术，目前是分析化学领域最大的一个分支，其应用领域和分析对象最为广泛，几乎所有的物质都可以采用色谱技术进行分离、制备和分析。物质分离、制备与分析是物质科学研究的基础和前提，化学、生物、医学、药学、化工、材料、环境等众多学科的发展对物质分离、制备与分析都有广泛的需求。 
        </p>
        
        <p className={styles.p}>
        色谱与分离组是分析中心的重要组成成员，期间由于技术人员短缺一度中断，鉴于色谱分离分析的重要性，2020年中心重新恢复“色谱与分离组”。机组希望根据分析化学的特点和国际前沿研究领域的发展趋势，立足于中国现状，结合国家重大应用领域的需求与自身技术优势，以分离分析研究为立足点，生命科学、重大疾病、中医药现代化、公共安全等领域的复杂样品分析为切入点，开展极端复杂体系分析的方法学研究及其应用、组学方法及其应用研究和转化医学等工作。
        </p>
      </div>
    </div>
  );
};

export default app;



// WEBPACK FOOTER //
// ./src/pages/IntroduceDetail.js